import { MODAL_APPEARANCE_TIME } from '@shared/config/style/modal';
import { useEffect, useRef } from 'react';
import { FormRenderProps } from 'react-final-form';

export const useResetModalForm = <FormFields, FormInitialValues = Partial<FormFields>>(isShow: boolean) => {
    const timeoutId = useRef<NodeJS.Timeout>();
    const formRef = useRef<FormRenderProps<FormFields, FormInitialValues>>();

    useEffect(() => {
        const form = formRef.current;
        const existedReset = timeoutId.current;
        if (!isShow && form) {
            timeoutId.current = setTimeout(() => {
                form.form.reset();
            }, MODAL_APPEARANCE_TIME);
        } else if (isShow && existedReset) {
            clearTimeout(existedReset);
        }
    }, [isShow]);

    return formRef;
};
